<div class="c-splash-screen" [@fadeInOut]="animationState">
    <div class="c-splash-screen__content">
        <div
            class="c-splash-screen__dots"
            [@dotsAnimation]="dotsState"
            [class.centering]="dotsState === 'centering'"
        >
            <div class="c-splash-screen__dot c-splash-screen__dot--1"></div>
            <div class="c-splash-screen__dot c-splash-screen__dot--2"></div>
            <div class="c-splash-screen__dot c-splash-screen__dot--3"></div>
        </div>
        <img
            src="images/logos/nucont-n.svg"
            alt="Nucont Logo"
            class="c-splash-screen__logo"
            [@scaleLogo]="logoState"
        />
    </div>
</div>
